import { CartProductUI } from './CartProductUI';
import { useEffectiveEquivalenceCharges } from '../../../user/application/useEffectiveEquivalenceCharges';
import { calculateDiscountPercentage } from '../../../helpers/calculateDiscountPercentage';
import { useCartContext } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
export const CartProduct = ({ product, isDeprecated = false, displayQuantity }) => {
  const { changeEquivalenceCharges, removeProduct } = useCartContext();
  const equivalenceCharges = useEffectiveEquivalenceCharges();
  const navigate = useNavigate();

  const editProduct = (product) => {
    navigate(`/articulos/${encodeURIComponent(product.code)}`);
  };

  return (
    <CartProductUI
      data={{
        product: product,
        productDiscount: product && calculateDiscountPercentage(product.basePrice, product.sellingPrice),
        promotionDiscount: product?.promotionDiscount ?? 0,
        userEquivalenceCharges: equivalenceCharges,
        isDeprecated: isDeprecated,
        displayQuantity: displayQuantity
      }}
      actions={{
        changeProductEquivalenceCharges: () => changeEquivalenceCharges(product),
        edit: () => editProduct(product),
        remove: () => removeProduct(product)
      }}
    />
  );
};